import * as React from "react";
import { inject,observer } from 'mobx-react';
import ModelStore from 'src/stores/ModelStore';
import './NavigationComponent.scss';
import IMenuItem from "src/interfaces/IMenuItem";
import MainNavigationItemComponent from "./MainNavigationItemComponent";

interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class NavigationComponent extends React.Component<IProps,{}> {


  public render() {
      const modelStore = this.props.modelStore as ModelStore;
      return (
        <div className={ "main-nav step-" + modelStore.selectedIndex}>
          { this._renderItems()}
        </div>
    ); 
  }
  
  /*
  private _selectMenu (model:IMenuItem){
    const modelStore = this.props.modelStore as ModelStore;
    modelStore.setSelectedMenu(model);
  }
  */

  private _renderItems():React.ReactNode[]{
      const modelStore = this.props.modelStore;
      const items: any[] = [];
      modelStore!.menuItems.map( 
        (model: IMenuItem , index: number )=>{
        items.push(<MainNavigationItemComponent index={index} model={model} key={'card-' + index } />);
      }); 
      return items;
  }

}


// WEBPACK FOOTER //
// ./src/components/NavigationComponent.tsx